import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { useErrorMessages } from '../../../models/hooks/appStateHooks';
import { IVolunteerFilter, useExportVolunteersMutation } from '../../../queries/Volunteer';
import { Button } from '../../components-v2/Button';
import { ExportConfirmationModalV2 } from '../../components/ExportConfirmation';
import { styleSheet } from './styles';

const VOLUNTEER_EXPORT_FIELDS =
	'Contact Id, Volunteer Name, Activity, Role, Date, Shift Start, Shift End, Check In, Check Out, Hours, Status, Location';

interface IProps {
	filter?: IVolunteerFilter;
	excludeActivityIds?: string[];
	impersonationContext?: Api.IImpersonationContext;
}

export const ExportVolunteersButton = ({ filter, excludeActivityIds, impersonationContext }: IProps) => {
	const errorMessages = useErrorMessages();
	const exportMutation = useExportVolunteersMutation({
		onError: error => errorMessages.pushApiError(error),
	});

	return (
		<>
			<Button
				variant='secondary'
				isLoading={exportMutation.isPending}
				disabled={exportMutation.isPending}
				onClick={() => exportMutation.mutate({ filter, excludeActivityIds, impersonationContext })}
			>
				Export
			</Button>
			<ExportConfirmationModalV2
				mutationResult={exportMutation}
				impersonationContext={impersonationContext}
				modalProps={{
					isOpen: !exportMutation.isIdle,
					onRequestClose: () => exportMutation.reset(),
				}}
				subTitle={
					<p className={css(styleSheet.exportFields)}>
						One row per volunteer shift. The fields we&rsquo;ll export include: {VOLUNTEER_EXPORT_FIELDS}
					</p>
				}
			/>
		</>
	);
};
